import { render, staticRenderFns } from "./EmailSetting.vue?vue&type=template&id=717576dd"
import script from "./EmailSetting.vue?vue&type=script&lang=js"
export * from "./EmailSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('717576dd')) {
      api.createRecord('717576dd', component.options)
    } else {
      api.reload('717576dd', component.options)
    }
    module.hot.accept("./EmailSetting.vue?vue&type=template&id=717576dd", function () {
      api.rerender('717576dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/sysParam/EmailSetting.vue"
export default component.exports